// Import plugins and types
import { ExamplePlugin } from "../examples/types"
import { zeroConfigAnnouncementsPlugin } from "./announcements"
import { zeroConfigLinksPlugin } from "./links"

// Export all zero-config plugins
export { zeroConfigAnnouncementsPlugin } from "./announcements"
export { zeroConfigLinksPlugin } from "./links"

// Export utility functions
export const getAllZeroConfigPlugins = (): ExamplePlugin[] => {
  return [
    zeroConfigAnnouncementsPlugin,
    zeroConfigLinksPlugin,
    // Add other zero-config plugins here as they're created
  ]
}
